import { DesignSystemMembershipUpdates } from "@supernova-studio/model";
import { DTODesignSystemRole } from "./role";
import { z } from "zod";
//
// Read
//
export const DTODesignSystemMember = z.object({
    userId: z.string(),
    /**
     * Role that the member has in the design system,
     * undefined if set to inherit from workspace
     */
    designSystemRole: DTODesignSystemRole.optional(),
    isDeactivated: z.boolean(),
});
export const DTODesignSystemInvitation = z.object({
    id: z.string(),
    workspaceInvitationId: z.string(),
    /**
     * Role that the invitation has in the design system,
     * undefined if set to inherit from workspace
     */
    designSystemRole: DTODesignSystemRole.optional(),
});
export const DTODesignSystemMemberListResponse = z.object({
    members: DTODesignSystemMember.array(),
    invitations: DTODesignSystemInvitation.array(),
});
export const DTODesignSystemMembersUpdateResponse = z.object({
    ok: z.literal(true),
});
//
// Write
//
export const DTODesignSystemMembersUpdatePayload = DesignSystemMembershipUpdates;
